import { observer } from 'mobx-react';
import * as React from 'react';
import { AlreadyTranslatedText, T } from '../../../../../../Translations';
import Loader from '../../../../../Loader';
import LearningCollectionEditStore from '../../../Edit/Store';
import { LearningCollectionEditFormResource } from '../../../Edit/Store/Types';
import { SectionContext } from '../../../Types';
import ModalBody from './ModalBody';
import FilterContext from './ModalBody/FilterContext';
import ModalBodySelecting from './ModalBodySelecting';
import Store from './Store';

export interface Props {
  store: Store;
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  context: SectionContext;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

const ExperienceCatalogModalState: React.FC<Props> = ({
  store,
  learningDesignName,
  learningCollectionStore,
  context,
  learningCollectionEditFormResource,
}) => {
  switch (store.state.kind) {
    case 'waiting':
    case 'waiting-with-link':
      return <></>;
    case 'loading':
      return (
        <div className="h-[60vh]">
          <Loader className="h-[inherit]" />
        </div>
      );
    case 'loading-error':
      return (
        <div className="mt-32 h-[60vh]">
          <p>
            <T kind="An error occurred, please refresh the page and try again" />
          </p>
        </div>
      );
    case 'hiding':
    case 'showing':
      return (
        <FilterContext experiences={store.state.experiences}>
          <ModalBody
            store={store}
            experiences={store.state.experiences}
            learningDesignName={learningDesignName}
            learningCollectionStore={learningCollectionStore}
            context={context}
            learningCollectionEditFormResource={learningCollectionEditFormResource}
          />
        </FilterContext>
      );
    case 'selecting':
      return (
        <FilterContext experiences={store.state.experiences}>
          <ModalBody
            store={store}
            experiences={store.state.experiences}
            learningDesignName={learningDesignName}
            learningCollectionStore={learningCollectionStore}
            context={context}
            learningCollectionEditFormResource={learningCollectionEditFormResource}
          />
          <ModalBodySelecting
            learningCollectionStore={learningCollectionStore}
            experiences={store.state.experiences}
            learningDesignName={learningDesignName}
            store={store}
            context={context}
          />
        </FilterContext>
      );
  }
};

export default observer(ExperienceCatalogModalState);
